import React, { useEffect, useState,useRef } from 'react';
import { Container, Card, CardContent, TextField, Box ,Grid, Backdrop,Tabs, Tab,Dialog, DialogActions, DialogContent, DialogTitle, Typography,Button,CircularProgress,Input  } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import axios from 'axios';
import { BASE_URL } from '../../App';
import * as XLSX from 'xlsx';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper ,Switch, FormControlLabel} from '@mui/material';
import Swal from 'sweetalert2';
import { IconButton } from '@mui/material';
import { Edit, Visibility } from '@mui/icons-material';
import { GetApp, ShoppingCart } from '@mui/icons-material';
import ExcelJS from "exceljs";
const MyCardWithAutocomplete = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedType, setselectedType] = useState(null);
  const [dealers, setDealers] = useState([]);
  const [excelData, setExcelData] = useState([]);
    const [open, setOpen] = React.useState(false);
  const [uploadingdata, setUploadingdata] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const login_id=localStorage.getItem("LOGIN_ID");
const [selectedTab, setSelectedTab] = useState(0);
const [selectedRow, setSelectedRow] = useState(null); // State to hold the selected row data for the modal
const [selectedRoww, setSelectedRoww] = useState([]); // State to hold the selected row data for the modal
const [dialogOpen, setDialogOpen] = useState(false);
const [dialogOpenn, setDialogOpenn] = useState(false);
const handleTabChange = (event, newValue) => {
  setSelectedTab(newValue);
};
const [editedData, setEditedData] = useState(selectedRow);
  const [isFileValid, setIsFileValid] = useState(true);
  const [showTable, setShowTable] = useState(false);
const [tableData, setTableData] = useState([]);
const [chkupload, setchkupload] = useState([]);
const typeoptions=[{Label:'ALL',value:'ALL'},{Label:'PO GENERATED',value:'POGENERATED'},{Label:'PO PENDING',value:'POPENDING'},{Label:'INVOICE GENERATED',value:'INVOICEGENERATED'}]
  const handleFileUpload = (e) => {
   
     
    setShowTable(false);  
    setchkupload(e.target.value);
    const file = e.target.files[0];
    const fileName = file?.name.toLowerCase();
  
    // Regex to check if the file is an Excel file
    //const regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xlsx|.xls)$/;
    const regex = /\.xlsx|\.xls$/;

    if (regex.test(fileName)) {
      const xlsxFlag = fileName.indexOf(".xlsx") > 0;
  
      if (typeof FileReader !== "undefined") {
        const reader = new FileReader();
  
        reader.onload = (event) => {
          const data = event.target.result;
          let workbook;
  
          if (xlsxFlag) {
            workbook = XLSX.read(data, { type: 'array' });
          } else {
            workbook = XLSX.read(data, { type: 'binary' });
          }
  
          // Get sheet names
          const sheetNames = workbook.SheetNames;
          let cnt = 0;
  
          sheetNames.forEach((sheetName) => {
            if (cnt === 0) {
              // Read data from the first sheet
              const sheet = workbook.Sheets[sheetName];
              const excelData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
  
              if (excelData.length > 0) {
                setExcelData(excelData);
                setShowTable(true); // Show table if data exists
              }
              cnt++;
            }
          });
        };
  
        if (xlsxFlag) {
          reader.readAsArrayBuffer(file); // For .xlsx
        } else {
          reader.readAsBinaryString(file); // For .xls
        }
      } else {
        alert("Sorry! Your browser does not support HTML5!");
      }
    } else {
      // Handle invalid file type
      setIsFileValid(false);
      setShowTable(false);
    }
  };
  
  const downloadExcelTemplate = () => {
    // Define the template columns (header row)
    const templateData = [
      {
        "Dealer Code*": '',
        "Project ID*": '',
        "Beneficiary ID*": '',
        "Name*": '',
        "Address*": '',
        "City*": '',
        "District*": '',
        "State*": '',
        "Pincode": '',
        "Customer Contact Number*": '',
        "GST Number": '',
        "HP*": '',
        "MTR HEAD*": '',
        "System Installer Code*": '',
        "System Installer Name*": '',
        "System Installer Mobile No.*": '',
        "Model - Submersible / Surface*": '',
        "Item Code": '',
        "Active / Non-Active*(Active=1/Non-Active=0)": ''
      },
    ];

    // Create a worksheet from the template data
    const ws = XLSX.utils.json_to_sheet(templateData);

    // Apply styles to the header row (A1, B1, C1, etc.)
    Object.keys(ws).forEach((key) => {
      if (key.includes('1')) {  // Apply styles only to the first row (header)
        ws[key].s = {
          fill: {
            fgColor: { rgb: "1E90FF" }, // Background color (Dodger Blue)
          },
          font: {
            bold: true, // Bold text
            color: { rgb: "FFFFFF" }, // White text
          },
          alignment: {
            horizontal: "center", // Center align text horizontally
            vertical: "center", // Center align text vertically
          },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Template');

   
    XLSX.writeFile(wb, 'dealer_upload_template.xlsx');
  };
  
  const Exportorderdetails = () => {
	  
    // Map the existingcustomers data into a format suitable for Excel export
    const errorMessages = tableData.map((item) => ({
      'DealerCode': item.DealerCode,
      'ProjectID': item.ProjectID,
      'Beneficiary ID': item.BeneficiaryID,
      'DOC_NO': item.DOC_NO,
      'SAP_OrderNO': item.SAP_OrderNO,
      'Name': item.Name,
      'Address': item.Address,
      'City': item.City,
      'District': item.District,
      'State': item.State,
      'Pincode': item.Pincode,
      'Customer Contact Number': item.CustomerContactNumber,
      'GST Number': item.GSTNumber,
      'HP': item.HP,
      'Model': item.Model,
      'Item Code': item.ItemCode,
      'Status': item.Status,
      'Created By': item.CreatedBy,
      'Created On': item.CreatedOn,
      'Modified By': item.ModifiedBy,
      'Modified On': item.ModifiedOn,
    }));

    
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Set up columns dynamically based on errorMessages keys
    worksheet.columns = Object.keys(errorMessages[0]).map((key) => ({
      header: key,   // Column header
      key,           // Column key for referencing data
      width: 20,     // Optional: Set column width
    }));

    // Add rows to the worksheet
    errorMessages.forEach((data) => worksheet.addRow(data));

    // Style the header row
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'bf43bb' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
      };
    });

    // Optional: Add autoFilter to header
    worksheet.autoFilter = {
      from: 'A1',
      to: 'R1',  // Adjust this based on the number of columns
    };

    // Trigger download after a small delay for better UX
    setTimeout(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Solar_Beneficiary_Details.xlsx';
        link.click();
      });
    }, 1000);
  };
 
  const handlesave = async () => {
    try {
      
      setOpen(true);
      const uploadapi = BASE_URL+'/solarcustomercreation'
      const response = await axios.post(uploadapi, {login_id:login_id,solarcreation:excelData});
      
      
      if (response.status === 200) {
        setOpen(false);
       
        if (response.data.status_code === "600") {
          setchkupload([]);
          
          Swal.fire({
            icon: 'info',
            text: response.data.message,
            confirmButtonText: 'Download',
          }).then(() => {
            
            setOpen(true);
            const errorMessages = response.data.errors.map(error => ({
              'Beneficiary ID': error.BeneficiaryID,
              'Error Message': error.Errors,
            }));
    
            
            const ExcelJS = require('exceljs');
              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet('Sheet1');
  
             
              worksheet.columns = Object.keys(errorMessages[0]).map(key => ({ header: key, key }));
  
             
              errorMessages.forEach(data => worksheet.addRow(data));
  
             
              const headerRow = worksheet.getRow(1);
              headerRow.eachCell((cell) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'bf43bb' }
                };
                cell.font = {
                  bold: true,             
                  color: { argb: 'FFFFFF' }
                };
              });
             
              worksheet.autoFilter = {
                  from: 'A1',
                  to: 'I1'
              };
              setOpen(false);
             
              setTimeout(() => {
                  workbook.xlsx.writeBuffer().then((buffer) => {
                      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                      const link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = 'Solar_Customer_Error_Description.xlsx';
                      link.click();
                     
                  });
              }, 1000);

          });
         
          setExcelData([]);  
          setShowTable(false); 
        }
        
       if(response.data.status_code=="400")
       {
        setOpen(false);
           Swal.fire({
                  icon: 'info',
                  text: response.data.message,
                  confirmButtonText: 'Okay',
                });
       }
       if(response.data.status_code=="200")
        {
          setchkupload([]);
          setOpen(false);
            Swal.fire({
                   icon: 'success',
                   text: response.data.message,
                   confirmButtonText: 'Okay',
                 });
                 clearFileInput();
      
                     setExcelData([]);  
    setShowTable(false);
   
        }
  
      }
    } catch (error) {
      setOpen(false);
      console.error('Error uploading data:', error);
      alert('Error uploading data');
    }
  };
  const fileInputRef = useRef(null);
  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the file input value
    }
  }
  
  useEffect(() => {
    const fetchDealer = async () => {
      try {
        
        const response = await axios.post(`${BASE_URL}/dealercodes`, {
          login_id: 'ADMIN'
        });

        if (response.data.status_code === "200") {
         
         
          setDealers(response.data.dealers || []);
        } else {
          console.error('Invalid status code in the response');
        }
      } catch (error) {
        console.error('Error fetching dealer codes:', error);
      }
    };

    fetchDealer();
  }, [login_id]);

  const fetchData = async (dealerCode,type) => {
    try {
      setTableData([]);
      setOpen(true);
      setShowTable(false);
      const response = await axios.post(BASE_URL+'/existingcustomers',{login_id:login_id,dealercode:dealerCode,type:type});
     if(response.status===200)
     {
      setOpen(false);
      const transformedData = response.data.existingcustomers.map(customer => ({
        ...customer, // Spread the original customer data
        Status: customer.Status === "1" ? 'Active' : 'Inactive', // Add a new field `StatusText`
    }));

    setOpen(false);
    setTableData(transformedData);
   
      
     }
     
    } catch (error) {
      setOpen(false);
      console.error('Error fetching data:', error);
    }
  };
  const columns = [
    {
      header: 'Actions', // Column header for actions
      accessorKey: 'actions', // Placeholder accessor key (not directly related to the data)
      Cell: ({ row }) => (
        <div>
          {/* View button */}
          <IconButton
            color="primary"
            onClick={() => handleView(row)}
            aria-label="View"
          >
            <Visibility />
          </IconButton>

          {/* Edit button */}
          <IconButton
            color="secondary"
            onClick={() => handleEdit(row)}
            aria-label="Edit"
          >
            <Edit />
          </IconButton>
        </div>
      ),
    },
    { accessorKey: 'DealerCode', header: 'Dealer Code' },
    { accessorKey: 'ProjectID', header: 'Project ID' },
    { accessorKey: 'BeneficiaryID', header: 'Beneficiary ID' },
    { accessorKey: 'DOC_NO', header: 'DMS_ORDER_NO' },
    { accessorKey: 'SAP_OrderNO', header: 'SAP_ORDER_N0' },
    { accessorKey: 'Invoice_No', header: 'SAP_INVOICE_NO' },
    { accessorKey: 'Name', header: 'Name' },
    { accessorKey: 'Address', header: 'Address' },
    { accessorKey: 'City', header: 'City' },
    { accessorKey: 'District', header: 'District' },
    { accessorKey: 'State', header: 'State' },
    { accessorKey: 'Pincode', header: 'Pincode' },
    { accessorKey: 'CustomerContactNumber', header: 'Customer Contact Number' },
    { accessorKey: 'GSTNumber', header: 'GST Number' },
    { accessorKey: 'HP', header: 'HP' },
    { accessorKey: 'MTRHead', header: 'MTR Head' },
    { accessorKey: 'SystemInstallerCode', header: 'System Installer Code' },
    { accessorKey: 'SystemInstallerName', header: 'System Installer Name' },
    { accessorKey: 'SystemInstallerMobileNo', header: 'System Installer Mobile No' },
    { accessorKey: 'Model', header: 'Model' },
    { accessorKey: 'ItemCode', header: 'Item Code' },
    {
      header: 'Active/Inactive',
      accessorKey: 'Status', 
    },
   
    { accessorKey: 'CreatedOn', header: 'Created On' },
    { accessorKey: 'ModifiedOn', header: 'Modified On' },
    { accessorKey: 'ModifiedBy', header: 'Modified By' },
    { accessorKey: 'CreatedBy', header: 'Created By' },
  ];

  const handleView = (row) => {

    //console.log('ff',row);
    if (row.original) {
      setSelectedRoww(row.original); // Set the selected row's data
      setDialogOpen(true); // Open the dialog for view
    } else {
      console.error("No data found for this row.");
    }
    //setDialogOpen(true); 
  };

  const handleEdit = (row) => {
    console.log('ff',row);
    setSelectedRow(row.original);
    setEditedData(row.original);  
    setDialogOpenn(true);
    
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); 
    setSelectedRow(null); 
  };
  
  const handleCloseDialogg = () => {
    setDialogOpenn(false); 
    setEditedData(null); 
    setSelectedRow(null); 
  };

  const handleupdatee = async () => {
    try {
     
      const response = await axios.post(BASE_URL + '/updateExistingCustomers', {
        ...editedData, // Spread the properties of editedData
        login_id: login_id // Include the login_id in the request payload
      });
      
  
     
      console.log('Data saved successfully', response.data);
      if (response.status===200){

        setDialogOpenn(false)
        if(response.data.status_code='200')
        {
        
          Swal.fire({
            icon: 'success',
            text: response.data.message,
            confirmButtonText: 'Okay',
          });
        }
        if(response.data.status_code='400')
          {
            Swal.fire({
              icon: 'info',
              text: response.data.message,
              confirmButtonText: 'Okay',
            });
          }
      }
     
      
  
    } catch (error) {
     
      Swal.fire({
        icon: 'info',
        text: error,
        confirmButtonText: 'Okay',
      });
      
    }
  };



  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData({
      ...editedData,
      [name]: value,
    });
  };

 
  // useEffect(() => {
  //   if (selectedOption) {
  //     fetchData(selectedOption.DEALER_CODE); 
    
        
  //   }
  // }, [selectedOption]);

  useEffect(() => {
    if (selectedType) {
      if( selectedOption && selectedType){
        fetchData(selectedOption.DEALER_CODE,selectedType.value); 
        }
      else if(!selectedOption)
      {
        Swal.fire({
          icon: 'info',
          text: 'Please Select Dealer',
          confirmButtonText: 'Okay',
        });
      }
      else if(!selectedType)
        {
          Swal.fire({
            icon: 'info',
            text: 'Please Select Type',
            confirmButtonText: 'Okay',
          });
        }
    
        
    }
  }, [selectedType]);



 

  return (
    <Container maxWidth="lg" sx={{ paddingTop: '20px' }}>
<Card sx={{ width: '100%', padding: '20px' }}>
      <CardContent>
      
       

       
        <Box >
         
         
            <div>
           
            <Card sx={{ width: '100%', padding: '5px' }}>
  <CardContent>
  <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" gap={2}>
  <Typography variant="h6" sx={{ marginRight: '16px' }}>
    <b>Dealer Code / Name :</b>
  </Typography>

  <Autocomplete
    value={selectedOption}
    onChange={(event, newValue) => setSelectedOption(newValue)}
    options={dealers}
    getOptionLabel={(option) => `${option.DEALER_CODE} - ${option.DEALERNAME || ''}`}
    filterOptions={(options, state) =>
      options.filter(option =>
        option.DEALER_CODE.toLowerCase().includes(state.inputValue.toLowerCase()) ||
        option.DEALERNAME.toLowerCase().includes(state.inputValue.toLowerCase())
      )
    }
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
        sx={{
          width: '450px',
        }}
      />
    )}
  />

  <Autocomplete
    value={selectedType}
    onChange={(event, newValue) => setselectedType(newValue)}
    options={typeoptions}
   
    getOptionLabel={(option) => `${option.Label}`}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
         label="Select Type"
        sx={{
          width: '150px',
        }}
      />
    )}
  />
  <Button
        variant="contained"
        color="secondary"
		disabled={!tableData.length}
		startIcon={<GetApp />}  
        onClick={Exportorderdetails}
      >
       Export
      </Button>
  
</Box>

    
  </CardContent>
</Card>

            </div>
   <br/>
            {/* <div> */}
            <Card sx={{ width: '100%', padding: '5px' }}>
            <CardContent>
     <Box
      display="flex"
      justifyContent="center" 
      alignItems="center"      
      gap={2}
      
    >
    
      <Input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        inputProps={{ accept: '.xlsx, .xls' }}
        ref={fileInputRef}
        value={chkupload}
      />

<Button  variant="contained"
        color="primary" onClick={handlesave} disabled={!excelData.length}>
       Upload
      </Button>
      <Button
        variant="contained"
        color="success"
        onClick={downloadExcelTemplate}
      >
        Download Template
      </Button>
    </Box>
    </CardContent>
    </Card>

   <br/>
 <div >
   {!showTable ? (
  selectedOption ? (
    <MaterialReactTable 
      columns={columns}
      data={tableData}
      enablePagination
      enableSorting
      enableStickyHeader
      enableColumnFiltering
      initialState={{ pagination: { pageSize: 20 } }} // Initial pagination state
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: '#61d1e5', // Colorful header background
          color: '#000', // Text color for the header
          position: 'sticky', // Make the header sticky
          top: 0, // Keep the header at the top of the table when scrolling
          zIndex: 1, // Ensure header stays above the content
          fontWeight: 'bold', // Make header text bold
        },
      }}
    />
  ) : (
    <p></p> 
  )
) : (
  <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
    <Table
      style={{
        borderCollapse: 'separate',
        borderSpacing: '4px',
        width: '100%',
        textAlign: 'center',
        fontSize: '15px',
      }}
    >
      <TableHead
        sx={{
          position: 'sticky',
          top: 0,
          backgroundColor: '#61d1e5',
          padding: '5px',
          color: '#000',
          zIndex: 1,
        }}
      >
        <TableRow>
          {Object.keys(excelData[0]).map((key, index) => (
            <TableCell key={index} style={{ fontWeight: 'bold' }}>
              {key}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {excelData.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {Object.values(row).map((cell, cellIndex) => (
              <TableCell key={cellIndex}>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)}



</div>
<Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
      <DialogTitle>Customer Details</DialogTitle>
      <DialogContent>
      
        {selectedRoww && (
          <Grid container spacing={2}>
            {Object.keys(selectedRoww).map((key, index) => (
             
              index % 2 === 0 ? (
                <Grid item xs={6} key={key}>
                  <TextField
                    label={key}
                    value={selectedRoww[key]}
                    fullWidth
                    margin="normal"
                    InputProps={{
                      readOnly: true, 
                    }}
                    variant="outlined"
                  />
                </Grid>
              ) : (
                <Grid item xs={6} key={key}>
                  <TextField
                    label={key}
                    value={selectedRoww[key]}
                    fullWidth
                    margin="normal"
                    InputProps={{
                      readOnly: true, 
                    }}
                    variant="outlined"
                  />
                </Grid>
              )
            ))}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={dialogOpenn} onClose={handleCloseDialogg} maxWidth="md" fullWidth>
      <DialogTitle>Edit Customer Details</DialogTitle>
      <DialogContent>
        {selectedRow && (
          <Grid container spacing={2}>
           
           <Grid item xs={6}>
  <TextField
    label="Dealer Code"
    name="DealerCode"
    value={editedData.DealerCode || ''}
    fullWidth
    margin="normal"
    variant="outlined"
    InputProps={{
      readOnly: true,  // Set the field as readonly
    }}
  />
</Grid>
<Grid item xs={6}>
  <TextField
    label="Project ID"
    name="ProjectID"
    value={editedData.ProjectID || ''}
    fullWidth
    margin="normal"
    variant="outlined"
    InputProps={{
      readOnly: true,  // Set the field as readonly
    }}
  />
</Grid>
<Grid item xs={6}>
  <TextField
    label="Beneficiary ID"
    name="BeneficiaryID"
    value={editedData.BeneficiaryID || ''}
    fullWidth
    margin="normal"
    variant="outlined"
    InputProps={{
      readOnly: true,  // Set the field as readonly
    }}
  />
</Grid>

            <Grid item xs={6}>
              <TextField
                label="Name"
                name="Name"
                value={editedData.Name || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Address"
                name="Address"
                value={editedData.Address || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="City"
                name="City"
                value={editedData.City || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="District"
                name="District"
                value={editedData.District || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="State"
                name="State"
                value={editedData.State || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Pincode"
                name="Pincode"
                value={editedData.Pincode || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Customer Contact Number"
                name="CustomerContactNumber"
                value={editedData.CustomerContactNumber || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="GST Number"
                name="GSTNumber"
                value={editedData.GSTNumber || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="HP"
                name="HP"
                value={editedData.HP || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="MTR Head"
                name="MTRHead"
                value={editedData.MTRHead || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="System Installer Code"
                name="SystemInstallerCode"
                value={editedData.SystemInstallerCode || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="System Installer Name"
                name="SystemInstallerName"
                value={editedData.SystemInstallerName || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="System Installer Mobile No"
                name="SystemInstallerMobileNo"
                value={editedData.SystemInstallerMobileNo || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Model"
                name="Model"
                value={editedData.Model || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Item Code"
                name="ItemCode"
                value={editedData.ItemCode || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}>
  <FormControlLabel
    label={editedData.Status =='Active'  ? "Active" : "Inactive"} 
    control={
      <Switch
        checked={editedData.Status =='Active'}
        onChange={(e) => {
          const newValue = e.target.checked ? 1 : 0;
          setEditedData({
            ...editedData,
            Status: newValue,
          });
        }}
        name="Active"
        color="primary"
      />
    }
  />
</Grid>
<Grid item xs={3}></Grid>
<Grid item xs={3}></Grid>
  <Grid item xs={2}></Grid> {/* Empty space on the left */}
  <Grid item xs={4}>
    <Button
    style={{width:'250px'}}
      variant="contained"
      onClick={() => {
        console.log('Saved Data:', editedData); // Handle saving the edited data
        handleupdatee(); // Close dialog after save
      }}
      color="primary"
    >
      Save
    </Button>
  </Grid>
  <Grid item xs={4}>
    <Button onClick={handleCloseDialogg} color="secondary" 
       style={{width:'250px'}} variant="contained">
      Close
    </Button>
  </Grid>
  <Grid item xs={2}></Grid> {/* Empty space on the right */}


          </Grid>
        )}
      </DialogContent>
      <DialogActions>
       
        
      </DialogActions>
    </Dialog>
        </Box>
      </CardContent>
    </Card>
    <br/>
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
            <CircularProgress color="inherit" />
          </Backdrop>

    </Container>
  );
};

export default MyCardWithAutocomplete;


